<template>
  <div class="pageContentHeader" :class="flag">
    <div class="pageContentHeader__row">
      <div class="pageContentHeader__left">
        <h1 v-if="isPageTitle" class="pageTitle">{{ title }}</h1>
	      <slot name="subTitle"></slot>
      </div>
      <div class="pageContentHeader__right">

	      <slot name="customButtons"></slot>

	      <div class="d-flex align-center" v-if="selectConfig">
		      <span v-if="selectConfig.selectText">{{ selectConfig.selectText }}</span>
		      <field
				      :margin="selectConfig.margin"
				      :width="selectConfig.width"
				      :label="selectConfig.label"
				      :placeholder="selectConfig.placeholder"
				      @updateSelect="onSelect"
				      :autocompleteValue="selectConfig.selectValue"
				      :items="selectConfig.selectItems"
				      :isClearable="false"
				      :item-text="selectConfig.text"
				      :item-value="selectConfig.value"
				      is-select
		      ></field>
	      </div>

	      <v-btn
			      v-if="textReports"
			      @click="onClick({ flag: 'reports' })"
			      color="blue-grey"
			      depressed
			      class="reportsBtn"
			      :disabled="permissionsReports"
	      >
		      {{ textReports }}
	      </v-btn>

	      <v-btn
			      v-if="isCreate"
			      @click="onClick({ flag: 'create' })"
			      color="success"
			      :disabled="permissionsCreate"
	      >
		      <span class="btnIco"><svg-sprite icon-id="plus"/></span>
		      <span class="btnText">{{ textCreate }}</span>
	      </v-btn>

      </div>
    </div>
    <div class="pageContentHeader__row"
         v-if="
           !!isSearch ||
           !!isSend2 ||
           !!isAllFilterActive ||
           !!isFilterRefresh ||
           !!isSettings ||
           !!exportList ||
           !!isExport ||
           !!isUpload ||
           !!isInfo ||
           !!isBackList ||
           !!send">

      <div class="pageContentHeader__left">

        <div v-if="isSearch" class="search">
          <div class="search__wrap">
            <v-text-field
              v-model="search"
              :label="labelSearch"
              class="search__table"
              @keyup.enter="onSearch"
            ></v-text-field>
            <span class="icoSvg"
              ><svg-sprite
                icon-id="icon_search"
                width="14"
                height="14"
              ></svg-sprite
            ></span>
          </div>
        </div>

      </div>
      <div class="pageContentHeader__right">

        <slot name="customSubButtons"></slot>

	      <button
          v-if="isSend2"
          :disabled="isSendDisabled"
          class="mainBtn mainBtn-text"
          @click="onClick({ flag: 'send' })"
        >
	        <span class="btnIco"
	        ><svg-sprite icon-id="icon_send" width="18" height="18"></svg-sprite
          ></span>
	        <span class="btnText">{{ textSend2 }}</span>
        </button>

        <button
		        v-if="isAllFilterView"
          class="mainBtn mainBtn-text"
          :class="{ active: isAllFilterActive }"
          @click="onAllFilter()"
        >
          <span class="btnIco"
            ><svg-sprite icon-id="filter" width="20" height="20"></svg-sprite
          ></span>
          <span class="btnText">All filters</span>
        </button>
        <button
          v-if="isFilterRefresh"
          class="mainBtn mainBtn-text iconHoverRotate"
          @click="onClick({ flag: 'refresh' })"
        >
          <span class="btnIco"
            ><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite
          ></span>
          <span class="btnText">Refresh filters</span>
        </button>

        <button
          v-if="isSettings"
          class="mainBtn mainBtn-text iconHoverRotate"
          @click="onClick({ flag: 'settings' })"
        >
          <span class="btnIco"
            ><svg-sprite icon-id="setting" width="20" height="20"></svg-sprite
          ></span>
          <span class="btnText">Settings</span>
        </button>

        <template v-if="isExport && exportList && exportList.length">
          <field
            borderRadius="4px 0px 0px 4px"
            margin="0 0 0 0"
            width="160px"
            @updateSelect="onSelect"
            :autocompleteValue="exportStart"
            :items="exportList"
            :isClearable="false"
            is-select
          ></field>
          <button
            class="mainBtn mainBtn-text"
            @click="onClick({ flag: 'exportList' })"
          >
            <span class="btnIco"
              ><svg-sprite icon-id="upload" width="20" height="20"></svg-sprite
            ></span>
            <span class="btnText">Export</span>
          </button>
        </template>

        <button
          v-if="isExport"
          class="mainBtn mainBtn-text"
          @click="onClick({ flag: 'export' })"
          :disabled="permissionsExport"
        >
          <span class="btnIco"
            ><svg-sprite icon-id="upload" width="20" height="20"></svg-sprite
          ></span>
          <span class="btnText">Export</span>
        </button>

        <button
          v-if="isUpload"
          class="mainBtn mainBtn-text"
          @click="onClick({ flag: 'upload' })"
        >
          <span class="btnIco"
            ><svg-sprite
              icon-id="icon_download"
              width="20"
              height="20"
            ></svg-sprite
          ></span>
          <span class="btnText">Upload</span>
        </button>

        <button
          v-if="isInfo"
          class="mainBtn"
          @click="onClick({ flag: 'info' })"
        >
          <span class="btnText">{{ infoText }}</span>
        </button>

        <button
          v-if="isBackList"
          class="mainBtn mainBtn-text"
          @click="onClick({ flag: 'back' })"
        >
          <span class="btnIco"
            ><svg-sprite icon-id="icon_back" width="8" height="12"></svg-sprite
          ></span>
          <span class="btnText">Back to list</span>
        </button>

        <button
          v-if="send"
          :disabled="!isSend"
          class="mainBtn"
          @click="onClick({ flag: 'send' })"
        >
          <span class="btnText">{{ sendText }}</span>
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "PageContentHeader",
	props: {
		flag: String,
		selectConfig: Object,
		title: String,
		isPageTitle: Boolean,
		exportStart: Object,
		exportList: Array,
		isBackList: Boolean,
		textReports: String,
		isFilterRefresh: Boolean,
		isSearch: Boolean,
		isSettings: Boolean,
		isCreate: Boolean,
		isCreatePermissions: Boolean,
		textCreate: String,
		isInfo: Boolean,
		infoText: String,
		send: Boolean,
		isSend: Boolean,
		isExport: Boolean,
		isExportPermissions: Boolean,
		isUpload: Boolean,
		permissionsReports: Boolean,
		permissionsCreate: Boolean,
		sendText: String,
		isRefresh: String,
		isSend2: [ Boolean, Array ],
		textSend2: String,
		labelSearch: String,
		isAllFilterActive: {
			type: Boolean,
			default: false,
		},
		isAllFilterView: Boolean,
	},
	computed: {
		...mapGetters([ "permissions" ]),
		isSendDisabled() {
			if (Array.isArray(this.isSend2)) {
				return !this.isSend2.length;
			}

			return false;
		},
		getPermissions() {
			return PERMISSIONS;
		},
		// permissionsCreate() {
		// 	if (this.isCreatePermissions) return false;
		// 	if (typeof this.permissions[PERMISSIONS.CREATE] !== "undefined") {
		// 		return !this.permissions[PERMISSIONS.CREATE];
		// 	} else if (
		// 		typeof this.permissions[PERMISSIONS.CREATE_EDIT_TRIP] !== "undefined"
		// 	) {
		// 		return !this.permissions[PERMISSIONS.CREATE_EDIT_TRIP];
		// 	}
		// 	return false;
		// },
		permissionsExport() {
			if (this.isExportPermissions) return false;
			return !this.permissions[this.getPermissions.EXPORT];
		},
	},
	watch: {
		isRefresh(value, oldValue) {
			if (value !== oldValue) {
				this.search = "";
			}
		},
	},
	data() {
		return {
			search: "",
			selectedExportListValue: this.exportStart,
		};
	},
	methods: {
		onSelect({ value }) {
			this.selectedExportListValue = value;
		},
		onSearch() {
			this.$emit("updateSearch", this.search);
		},
		onClick(value) {
			const { flag } = value;
			if (flag === "exportList") {
				value.value = this.selectedExportListValue;
			}

			this.$emit("updateClick", value);
		},
		onAllFilter() {
			this.$emit("updateAllFilter");
		}
	},
};
</script>

<style lang="scss" scoped>
.pageContentHeader {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 10px;

	&__right {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}
}

</style>

<style lang="scss">
@import "PageContentHeaderAll";
</style>
